import type { ImageProps, Slide } from '@features/powerpoint';
import { chartOptionsToBase64Svg } from '@features/powerpoint';
import { contentSlideHeaderV2 } from '../../../../../../utils/slide-header-v2';
import { buildChartOptions } from '@configurations/campaignAnalytics/visitsByHourOfDayChart';
import { CHART_HEIGHT, CHART_IMAGE_OPTIONS, CHART_WIDTH } from './charts-v2';
import type { CampaignAnalyticsSlidesV2Props } from '../build-campaign-analytics-slides-v2';
import type { Options } from 'highcharts';

export const visitsByTimeOfDayChartSlideV2 = (
  props: CampaignAnalyticsSlidesV2Props
): Slide => {
  const chartOptions: Options = buildChartOptions(
    props.campaignAnalyticsReport.visitsByHourOfDay.data
  );

  const chartSVG: string = chartOptionsToBase64Svg({
    chartOptions,
    height: CHART_HEIGHT,
    width: CHART_WIDTH,
  });

  const images: ImageProps[] = [
    {
      data: chartSVG,
      ...CHART_IMAGE_OPTIONS,
    },
  ];

  return {
    slideMaster: props.slideMaster,
    texts: [contentSlideHeaderV2('Visits By Time Of Day')],
    images,
  };
};
